import * as React from "react";
import { Car, Bus, Building2, MapPin, ExternalLink } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const practicalInfo = [{
  title: "Headquarters Location",
  icon: Building2,
  description: "Our primary operations center in the heart of Abu Dhabi.",
  details: ["Office 9, 18th Floor, Al Ferdous Tower", "21 Al Durri Street, Al Danah, Zone 1", "Abu Dhabi, United Arab Emirates"]
}, {
  title: "Direct Contact",
  icon: MapPin,
  description: "Reach our consultancy experts directly.",
  details: ["Office: +971 2 622 5104", "Mobile: +971 50 721 7976", "Email: info@fetc.ae"]
}, {
  title: "Plan Your Visit",
  icon: Car,
  description: "Access and parking for our corporate clients.",
  details: ["Visits by prior appointment", "VIEW_MAP_BUTTON", "Business enquiries welcome"]
}];
export default function AbuDhabiHeadquarters() {
  return <section data-section-id="265065" id="abu-dhabi-headquarters" className="w-full py-16 md:py-24 bg-secondary text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        
        <div className="flex flex-col items-center text-center mb-12 md:mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight" style={{
          color: '#13B8C8'
        }}>Abu Dhabi Headquarters</h2>
          <p className="text-lg text-muted-foreground max-w-2xl font-default">
            FETC is based in Abu Dhabi, supporting organizations across the UAE with cybersecurity, technology consulting and digital transformation services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {practicalInfo.map((info, i) => {
          const Icon = info.icon;
          return <Card key={i} data-index={i} className="border-border/50 shadow-md hover:shadow-xl transition-all duration-300 bg-card overflow-hidden group border-t-2 hover:border-t-[#13B8C8]">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-md bg-[#13B8C8]/5 flex items-center justify-center mb-4 group-hover:bg-[#13B8C8]/10 transition-colors duration-300">
                    <Icon className="w-6 h-6" style={{
                  color: '#13B8C8'
                }} />
                  </div>
                  <CardTitle className="text-xl font-default font-semibold text-card-foreground">
                    {info.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {info.details.map((detail, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-sm bg-[#13B8C8]" aria-hidden="true" />
                        <span className="text-sm md:text-base text-muted-foreground leading-relaxed font-default w-full">
                          {detail === "VIEW_MAP_BUTTON" ? <Button asChild variant="outline" size="sm" className="mt-1 border-[#13B8C8] text-[#13B8C8] hover:bg-[#13B8C8] hover:text-white transition-colors">
                              <Link to="https://maps.app.goo.gl/1ep2Mixk512VVDsXA" newTab={true} className="flex items-center gap-2">
                                View location on Google Maps
                                <ExternalLink className="w-3 h-3" />
                              </Link>
                            </Button> : detail}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>

      </div>
    </section>;
}